export default function Contact() {
  return (
    <section id="contact" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
            联系我们
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
            联系我们
          </h2>
          <p className="mt-2 text-foreground-500 text-sm md:text-base">
            有任何问题或合作意向，欢迎通过以下方式与我们取得联系
          </p>
        </div>

        <div className="bg-white rounded-2xl p-8 md:p-10">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
            <div className="text-center p-6 rounded-xl bg-background-50">
              <div className="w-14 h-14 rounded-2xl bg-primary-100 flex items-center justify-center mx-auto mb-4">
                <i className="ri-mail-line text-primary-600 text-2xl"></i>
              </div>
              <h3 className="text-base font-heading font-bold text-foreground-900 mb-2">商务合作</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                广告投放、内容合作、版权授权等商务事宜，请发送邮件与我们洽谈
              </p>
              <p className="text-sm text-primary-600 font-medium mt-3">biz@yayacinema.com</p>
            </div>

            <div className="text-center p-6 rounded-xl bg-background-50">
              <div className="w-14 h-14 rounded-2xl bg-accent-100 flex items-center justify-center mx-auto mb-4">
                <i className="ri-bug-line text-accent-600 text-2xl"></i>
              </div>
              <h3 className="text-base font-heading font-bold text-foreground-900 mb-2">问题反馈</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                播放问题、功能建议或Bug报告，我们的技术团队将尽快处理
              </p>
              <p className="text-sm text-accent-600 font-medium mt-3">feedback@yayacinema.com</p>
            </div>

            <div className="text-center p-6 rounded-xl bg-background-50">
              <div className="w-14 h-14 rounded-2xl bg-secondary-100 flex items-center justify-center mx-auto mb-4">
                <i className="ri-user-add-line text-secondary-600 text-2xl"></i>
              </div>
              <h3 className="text-base font-heading font-bold text-foreground-900 mb-2">加入我们</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                内容编辑、字幕翻译、社区运营等岗位长期招募热爱影视的小伙伴
              </p>
              <p className="text-sm text-secondary-600 font-medium mt-3">hr@yayacinema.com</p>
            </div>
          </div>

          <div className="mt-8 p-6 rounded-xl bg-background-50 text-center">
            <p className="text-sm text-foreground-500">
              工作时间：周一至周五 9:00-18:00 · 我们会在24小时内回复您的来信
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}